import React from "react";
import PageHeadline from "../../components/shared/PageHeadline";
import { useTranslation } from "react-i18next";
import ImageGroupOfThree from "../../assets/images/special-program/GROUP-OF-3-CLOSE.jpeg";
import ImageBankBJBProgram from "../../assets/images/special-program/BANK-BJB-PROGRAM-REGIS.jpeg";
import ImageBankBJBBundlingProgram from "../../assets/images/special-program/BANK-BJB-BUNDLING-PROGRAM-REGIS.jpeg";
import ImageKompasIdProgram from "../../assets/images/special-program/KOMPAS.ID-REGIS.jpg";

export default function SpecialProgram() {
  const { t } = useTranslation();

  const items = [
    {
      img: ImageGroupOfThree,
      link: "/registration-group",
      alt: "Group of Three",
      disabled: false,
    },
    {
      img: ImageKompasIdProgram,
      link: "https://campaign.kompas.id/theultimate10kseries/#snk",
      alt: "Kompas.id Program",
      disabled: false,
    },
    {
      img: ImageBankBJBBundlingProgram,
      link: "https://bankbjb.co.id/promo/the-ultimate-10k-series",
      alt: "BJB Bundling Program",
      disabled: false,
    },
    {
      img: ImageBankBJBProgram,
      link: "https://www.bankbjb.co.id/promo/tangerang-10k",
      alt: "BJB Program",
      disabled: false,
    },
  ];

  return (
    <div className="text-white">
      <div className="relative min-h-[180px] lg:min-h-[300px] bg-brand-blue bg-contain md:bg-cover bg-no-repeat top-[56px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
        <PageHeadline title={t("specialProgramTitle")} />
      </div>

      <div className="top-0 md:top-40 lg:top-60 relative bg-white 2xl:px-0 md:px-14 pb-36 md:pb-48 lg:pb-96 2xl:pb-44 lg:mb-24 px-4 md:px-0 justify-center flex flex-col items-center">
        <div className="mt-10 grid grid-cols-2 gap-6 md:gap-8 max-w-6xl w-full mx-auto">
          {items.map((item, index) => {
            const Wrapper = item.disabled ? "div" : "a";

            return (
              <Wrapper
                key={index}
                {...(!item.disabled && { href: item.link })}
                className={`block relative group overflow-hidden ${item.disabled ? "cursor-not-allowed" : ""
                  }`}
              >
                <img
                  src={item.img}
                  alt={item.alt}
                  className={`w-full h-full object-cover transition-transform duration-300 group-hover:scale-105 ${item.disabled ? "grayscale opacity-60" : ""
                    }`}
                />

                {/* {item.disabled && (
                  <div className="absolute inset-0 bg-black/30 flex items-center justify-center font-poppins text-white text-lg font-semibold">
                    Sold Out
                  </div>
                )} */}
              </Wrapper>
            );
          })}
        </div>
      </div>
    </div>
  );
}
